import axios from "./axios";

export const search = params => {
  return axios.get("/fbmain/main/v1/public_sentimen", { params });
};
export const queryList = params => {
  return axios.get("/fbmain/main/v1/overview_public", { params });
};
export const collectGroup = params => {
  return axios.get("/fbmain/search/v1/collect_group_list", { params });
};
export const collect = params => {
  return axios.post("/fbmain/search/v1/favorite_article_option", params);
};
export const addGroup = params => {
  return axios.post("/fbmain/search/v1/collect_group_add", params);
};
export const delGroup = params => {
  return axios.delete("/fbmain/search/v1/collect_group_delete", {params});
};
export const updateGroup = params => {
  return axios.put("/fbmain/search/v1/collect_group_rename", params);
};
export const searchPublic  = params => {
  return axios.get('/fbmain/search/v1/main/detail',{params})
};
export const getUserInfo  = params => {
  return axios.get('/fbmain/user/v1/user_info',{params})
};


// WEBPACK FOOTER //
// ./src/api/publicSentiment.js